import { render, staticRenderFns } from "./RolePermissionItem.vue?vue&type=template&id=85b62a04&scoped=true&"
import script from "./RolePermissionItem.vue?vue&type=script&lang=js&"
export * from "./RolePermissionItem.vue?vue&type=script&lang=js&"
import style0 from "./RolePermissionItem.vue?vue&type=style&index=0&id=85b62a04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b62a04",
  null
  
)

export default component.exports